interface EquipamentoProps {
  id: string
  nome: string
  acessorios: string | null
  numSerie: string | null
}

export class Equipamento {
  constructor(private readonly props: EquipamentoProps) {}

  get id() {
    return this.props.id
  }

  get nome() {
    return this.props.nome
  }

  get acessorios() {
    return this.props.acessorios
  }

  get numSerie() {
    return this.props.numSerie
  }
}
